import styles from './TaskStatusSelector.module.css';
import { type CustomFieldOption } from '@he-novation/config/types/custom-field.types';
import {
    MultiActionButton,
    MultiActionButtonProps
} from '@he-novation/design-system/components/buttons/MultiActionButton/MultiActionButton';
import { DiscText } from '@he-novation/design-system/components/text/DiscText/DiscText';
import { DirectionX, DirectionY } from '@he-novation/design-system/utils/getAbsolutePosition';
import cn from 'classnames';

type TaskStatusSelectorProps = Omit<MultiActionButtonProps, 'actions'> & {
    statuses: CustomFieldOption[];
    status: string;
    setTaskStatus: (status: string) => void;
    displayStatus?: boolean;
    withChevron?: boolean;
    hoverable?: boolean;
};

export function TaskStatusSelector({
    statuses,
    status,
    setTaskStatus,
    displayStatus = true,
    withChevron,
    hoverable,
    icon,
    className,
    ...rest
}: TaskStatusSelectorProps) {
    return (
        <MultiActionButton
            {...rest}
            style={{
                background: statuses.find((s) => s.label === status)?.color || 'transparent'
            }}
            className={cn(styles.status, withChevron && 'rotate-icon-270', className)}
            icon={withChevron ? [{ name: 'chevron', stroke: 'black', fill: 'none' }] : icon}
            iconAfter={withChevron}
            direction={[DirectionX.RightInner, DirectionY.Bottom]}
            actions={statusToActions(statuses, status, setTaskStatus)}
            hoverable={hoverable}
        >
            {displayStatus && status}
        </MultiActionButton>
    );
}

function statusToActions(
    statuses: CustomFieldOption[],
    status: string,
    setStatus: (status: string) => void
) {
    return statuses.map((taskStatus) => ({
        id: taskStatus,
        disabled: taskStatus.label === status,
        children: <DiscText color={taskStatus.color || 'transparent'}>{taskStatus.label}</DiscText>,
        onClick: () => setStatus(taskStatus.label)
    }));
}
